import CollaborationService from './CollaborationService';

class CoderpadService implements CollaborationService {
  readonly name = 'CoderPad';

  readonly logoUrl = '/static/images/integrations/CoderPad.jpeg';
}

export default new CoderpadService();
